// Module
var code = "<md-icon class=\"material-icons md-{{ ::size }} work-order-priority-icon work-order-priority-icon--low\" md-svg-icon=\"/img/priority/low.svg\"></md-icon> ";
// Exports
module.exports = code;